import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private Invoice Types */
import {
  Settings,
  _Invoice
} from '../namespace-helper'

import _ from 'lodash'

// selected item template
const selectedInvoiceTemplate = {
  id: 0,
  invoices_types_id: 0,
  invoices_status_id: 0,
  currencies_id: 0,
  customers_id: 0,
  customers_branch_offices_id: 0,
  customers_branch_offices_contacts_id: 0,
  messages_id: 0,
  due_date: null
}

export default {
  namespaced: true,
  state: {
    invoices: [],
    selectedInvoice: _.cloneDeep(selectedInvoiceTemplate),
    openDialog: false,
    creatingInvoice: false
  },
  mutations: {
    [_Invoice.mutations.setInvoices] (state, payload) {
      state.invoices = payload
    },
    [_Invoice.mutations.setSelectedInvoice] (state, payload) {
      if (payload !== null) {
        state.selectedInvoice = payload
      } else {
        state.selectedInvoice = _.cloneDeep(selectedInvoiceTemplate)
      }
    },
    [_Invoice.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_Invoice.actions.saveInvoice] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/invoices'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            context.commit(_Invoice.mutations.setSelectedInvoice, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/invoices/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Invoice.actions.createFreeInvoice] (context, payload) {
      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/invoices/createFreeInvoice'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.loadInvoices] (context, payload) {
      console.log('loadInvoices: ' + JSON.stringify(payload))
      console.log('loadInvoices: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/invoices?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                'invoice_number:like;' +
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending +
                '&customersId=' + payload.customers_id +
                '&suppliersId=' + payload.suppliers_id +
                (payload.selectedFrom ? '&selectedFrom=' + payload.selectedFrom : '') +
                (payload.selectedTo ? '&selectedTo=' + payload.selectedTo : '') +
                (payload.filterDates ? '&filterDates=' + JSON.stringify(payload.filterDates) : '') +
                (payload.selectedInvoiceStatuses ? '&selectedInvoiceStatuses=' + JSON.stringify(payload.selectedInvoiceStatuses) : '')

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedInvoices: ' + JSON.stringify(r.data.data))
        context.commit(_Invoice.mutations.setInvoices, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Invoice.actions.loadInvoiceById] (context, payload) {
      console.log('loadInvoiceById: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/invoices/' + payload

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.sendInvoice] (context, payload) {
      console.log('sendInvoice: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/invoices/' + payload.id + '/sendInvoice'

      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        return axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.openCloseDialog] ({ commit }) {
      commit(_Invoice.mutations.setOpenCloseDialogState)
    },
    [_Invoice.actions.setSelectedInvoice] ({ commit }, payload) {
      commit(_Invoice.mutations.setSelectedInvoice, payload)
    },
    [_Invoice.actions.loadStatuses] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/invoiceStatuses'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.loadInvoiceTypes] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/invoiceTypes'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.deleteInvoice] (context, payload) {
      var url = API_URL + '/api/v1/invoices/' + payload.id

      console.log('deleteInvoice: ' + payload.id)

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.startPicking] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/invoices/startPicking/' + payload.id

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.createInvoice] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/invoices/createInvoice/' + payload.id + '?hideHSCode=' + payload.hideHSCode

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.reloadSelectedInvoice] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/invoices/' + payload
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Invoice.mutations.setSelectedInvoice, r.data.data)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Invoice.actions.resetState] ({ commit }, payload) {
      commit(_Invoice.mutations.setInvoices, [])
      commit(_Invoice.mutations.setSelectedInvoice, null)
    }
  },
  getters: {
    [_Invoice.getters.invoices] (state) {
      return state.invoices
    },
    [_Invoice.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_Invoice.getters.getSelectedInvoice] (state) {
      return state.selectedInvoice
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Invoice/invoices.js